import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { EmptyObject } from 'apollo-angular/types';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';

@Injectable()
export class ApolloService {
  constructor(public apollo: Apollo) {}

  public mutate(query: DocumentNode, variables: any, refetchQuery?: QueryRef<any, EmptyObject>): void {
    this.apollo
      .mutate({
        mutation: query,
        variables
      })
      .subscribe(() => {
        if (refetchQuery) {
          refetchQuery.refetch();
        }
      });
  }

  public mutateAndExecute(query: DocumentNode, variables: any, callback: (arg: any) => void ): void{
    this.apollo
    .mutate({
      mutation: query,
      variables
    })
    .subscribe( ( result ) => {
      if (callback) {
        callback( result );
      }
    });
  }

  public query<T>(query: DocumentNode, variables?: any): Observable<any> {
    return this.apollo.query<T>({
      query,
      variables
    });
  }

}
